import arrayHelper from './arrayObjectHelper';

const mainIframeSelector = '#chargify-js-main-iframe';

const getIframeSelectors = ({ fields }) => {
  const selectors = [];

  Object.keys(fields).forEach((fieldName) => {
    const selector = fields[fieldName].selector;
    if (!arrayHelper.includes(selectors, selector)) {
      selectors.push(selector);
    }
  });

  return selectors;
};

const generateMainIframeName = () =>
  `${mainIframeSelector}%${generateRandomString()}`;

const getIframeName = (type, selector) => `%${type}%${selector}`;

const isNameIncludesType = (name, type) => name && name.includes(`%${type}%`);

const generateIframeUniqueId = (selector) =>
  `${selector}%${generateRandomString()}`;

const generateRandomString = (length = 30) =>
  [...Array(length)].map(() => Math.random().toString(36)[2] || '0').join('');

const rendersField = (fieldName, fields, iframeSelector) => {
  if (!fields[fieldName]) return false;

  return iframeSelector === fields[fieldName].selector;
};

export default {
  getIframeSelectors,
  getIframeName,
  rendersField,
  isNameIncludesType,
  mainIframeSelector,
  generateMainIframeName,
  generateIframeUniqueId,
  generateRandomString,
};
